import { isEmbedded, useParentPostMessage } from '@yes.technology/react-toolkit'
import { loginSucceeded } from 'authentication/Login/ducks/authentication'
import jwtDecode from 'jwt-decode'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { IframeAttributes } from 'shared/components/Iframe'

type OriginalSender = {
  source: string
}

type EventDataMessage = {
  height?: string
  finishedInteraction?: boolean
  workflowUuid: string
  interactionUuid: string
  type?: string
  url?: string
  token?: string
  expirationDate?: number
  originalSender?: OriginalSender
}

const useIframe = ({
  origin,
  src,
  title,
  name
}: {
  origin: string
  src: string
  title: string
  name: string
}) => {
  const [height, setHeight] = useState('100vh')
  const [iframeAttributes, setIframeAttributes] = useState<
    IframeAttributes | undefined
  >()
  const [isFinishedInteraction, setIsFinishedInteraction] =
    useState<boolean>(false)

  const { postMessage } = useParentPostMessage()

  const dispatch = useDispatch()

  const navigate = useNavigate()

  const redirectToUrl = useCallback(
    (url?: string) => {
      const absoluteUrlRegex = new RegExp('^(?:[a-z+]+:)?//', 'i')
      if (url) {
        absoluteUrlRegex.test(url)
          ? (window.location.href = url)
          : navigate(url)
      }
    },
    [navigate]
  )

  const receiveMessage = useCallback(
    (event: MessageEvent<EventDataMessage>) => {
      // TODO: Improve iframe recognition in case of two different iframes with same origin (URL =/= Origin)
      if (!origin.startsWith(event.origin)) return false

      const { finishedInteraction, height, type, originalSender } = event.data

      if (finishedInteraction) {
        setIsFinishedInteraction(finishedInteraction)
      }

      if (type === 'redirect') {
        if (isEmbedded()) {
          postMessage(event.data)
        } else {
          redirectToUrl(event.data.url)
        }
      }

      if (type === 'updateAuthToken') {
        const { token, expirationDate } = event.data
        if (!token || !expirationDate) return

        const decoded = jwtDecode<{ email: string }>(token)
        dispatch(
          loginSucceeded(decoded.email, {
            token,
            expiration_date: expirationDate
          })
        )

        if (isEmbedded()) {
          postMessage(event.data)
        }
      }

      if (type === 'redirectAndUpdateAuthToken') {
        const { token, expirationDate } = event.data
        if (!token || !expirationDate) return

        const decoded = jwtDecode<{ email: string }>(token)
        dispatch(
          loginSucceeded(decoded.email, {
            token,
            expiration_date: expirationDate
          })
        )

        if (isEmbedded()) {
          postMessage(event.data)
        } else {
          redirectToUrl(event.data.url)
        }
      }

      if (type === 'getSharedState') {
        if (isEmbedded()) {
          window.parent.postMessage(
            {
              type: 'getSharedState',
              originalSender: {
                source: name
              }
            },
            '*'
          )
        }
      }

      if (height) {
        setHeight(`${Math.ceil(Number(height) + 205)}`)
      }
    },
    [dispatch, name, origin, redirectToUrl] // postMessage foi implementado sem useCallback por isso não foi adicionado aqui
  )

  useEffect(() => {
    setIframeAttributes({
      src,
      height,
      title,
      name,
      allow: 'camera; geolocation; microphone'
    })
  }, [height, name, src, title])

  return {
    iframeAttributes,
    receiveMessage,
    isFinishedInteraction
  }
}

export default useIframe
